// extracted by mini-css-extract-plugin
export var box = "_77-1";
export var checkboxRow = "_77-8";
export var checked = "_77-2";
export var descriptionSpacer = "_77-a";
export var disabled = "_77-3";
export var icon = "_77-6";
export var input = "_77-0";
export var labelSpacer = "_77-9";
export var medium = "_77-5";
export var small = "_77-4";
export var text = "_77-7";